import req from "../methods/req"
import method from '../methods/method'

//获取合约模板分类
export const getTemplateCate = function (data){
    return req({
        url:'/manage/quality.template/getTemplateCate',
        ...data
    })
}
//合约模板列表
export const getTemplateList = function (data){
    return req({
        url:'/manage/quality.template/getTemplateList',
        ...data
    })
}



//保存合约模板配置
export const saveTemplateConfig = function (data){
    return req({
        url:'/manage/quality.template/saveTemplateConfig',
        ...data
    })
}
//保存模板
export const saveTemplate = function (data){
    return req({
        url:'/manage/quality.template/saveTemplate',
        ...data
    })
}


//获取品控记录列表
export const getQualityRecordList = function (data){
   return method.get_list({
        url:'/manage/quality.index/getQualityRecordList',
        ...data
    })
}


//获取品控信息详情
export const getQualityRecordDetail = function (data){
    return req({
        url:'/manage/quality.index/getQualityRecordDetail',
        ...data
    })
}

//表单工厂
export const getFactorySelect = function (data){
    return req({
        url:'/manage/quality.index/getFactorySelect',
        ...data
    })
}

//商品
export const getMaterialSelect = function (data){
    return req({
        url:'/manage/approve.select/getMaterialSelect',
        ...data
    })
}



//保存品控信息
export const saveQualityRecord = function (data){
    return req({
        url:'/manage/quality.index/saveQualityRecord',
        ...data
    })
}
//获取品控信息
export const getGoodsSelect = function (data){
    return req({
        url:'/manage/approve.select/getGoodsSelect',
        ...data
    })
}

//获取品控类型
export const getTemplateType = function (data){
    return req({
        url:'/manage/quality.template/getTemplateType',
        ...data
    })
}






//获取品项列表
export const getGoodsList = function (data){
   return method.get_list({
        url:'/manage/quality.goods/getGoodsList',
        ...data
    })
}


//保存品项信息
export const saveGoods = function (data){
    return req({
        url:'/manage/quality.goods/saveGoods',
        ...data
    })
}
//获取品项详情
export const getGoodsDetail = function (data){
    return req({
        url:'/manage/quality.goods/getGoodsDetail',
        ...data
    })
}

//修改品项状态
export const changeGoodsStatus = function (data){
    return req({
        url:'/manage/quality.goods/changeGoodsStatus',
        ...data
    })
}



//删除品项
export const deleteGoods = function (data){
    return req({
        url:'/manage/quality.goods/deleteGoods',
        ...data
    })
}
//获取品项下拉
export const qualityGoodsSelect = function (data){
    return req({
        url:'/manage/quality.goods/getGoodsSelect',
        ...data
    })
}


//获取品项类型
export const getType = function (data){
    return req({
        url:'/manage/quality.goods/getType',
        ...data
    })
}
//获取温度类型
export const getDensitySelect = function (data){
    return req({
        url:'/manage/quality.index/getDensitySelect',
        ...data
    })
}

//品控信息删除
export const deleteQualityRecord = function (data){
    return req({
        url:'/manage/quality.index/deleteQualityRecord',
        ...data
    })
}


//批量设置扭矩
export const batchSetGoods = function (data){
    return req({
        url:'/manage/quality.goods/batchSetGoods',
        ...data
    })
}

//批量设置扭矩
export const getLineSelect = function (data){
    return req({
        url:'/manage/quality.index/getLineSelect',
        ...data
    })
}


//根据品项切换模板
export const getGoodsTemplate = function (data){
    return req({
        url:'/manage/quality.template/getGoodsTemplate',
        ...data
    })
}

export const delDrpGoods = function (data){
    return req({
        url:'/manage/quality.goods/delDrpGoods',
        ...data
    })
}

export const getDailyQualityCount = function (data){
    return req({
        url:'/manage/quality.report/getDailyQualityCount',
        ...data
    })
}


export const getDailyQualityReport = function (data){
      return method.get_list({
        url:'/manage/quality.report/getDailyQualityReport',
        ...data
    })
}


export const exportDailyQualityReport = function (data){
    return req({
        url:'/manage/quality.report/exportDailyQualityReport',
        ...data
    })
}



